import React from "react";

export const ConsultantDetailSkeleton = () => {
  return (
    <div className="bg-white shadow-sm max-w-7xl mx-auto overflow-hidden px-4 py-6 sm:px-6 rounded-lg">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <div className="bg-white border border-gray-200 rounded-lg p-6">
            <div className="flex flex-col sm:flex-row gap-6">
              <div className="flex-shrink-0">
                <div className="rounded-lg w-32 h-32 bg-gray-200 animate-pulse" />
              </div>

              <div className="flex-1 space-y-4">
                <div className="h-6 w-48 bg-gray-200 rounded-md animate-pulse" />
                <div className="flex items-center gap-4">
                  <div className="h-4 w-32 bg-gray-200 rounded-md animate-pulse" />
                </div>
                <div className="space-y-2">
                  <div className="h-4 w-40 bg-gray-200 rounded-md animate-pulse" />
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white border border-gray-200 rounded-lg p-6 mt-6">
            <div className="h-6 w-24 bg-gray-200 rounded-md animate-pulse mb-4" />
            <div className="flex flex-wrap gap-2">
              {[1, 2, 3].map((i) => (
                <div
                  key={i}
                  className="h-6 w-24 bg-gray-200 rounded-full animate-pulse"
                />
              ))}
            </div>
          </div>

          <div className="bg-white border border-gray-200 rounded-lg p-6 mt-6">
            <div className="h-6 w-32 bg-gray-200 rounded-md animate-pulse mb-4" />
            <div className="space-y-3">
              <div className="h-4 w-64 bg-gray-200 rounded-md animate-pulse" />
              <div className="flex flex-wrap gap-3">
                {[1, 2, 3].map((i) => (
                  <div
                    key={i}
                    className="h-4 w-32 bg-gray-200 rounded-md animate-pulse"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-1">
          <div className="bg-white border border-gray-200 rounded-lg p-6">
            <div className="h-6 w-48 bg-gray-200 rounded-md animate-pulse mb-4" />
            <div className="space-y-4">
              {[1, 2, 3].map((i) => (
                <div
                  key={i}
                  className="flex justify-between items-center py-2 border-b border-gray-100"
                >
                  <div className="h-4 w-32 bg-gray-200 rounded-md animate-pulse" />
                  <div className="h-4 w-24 bg-gray-200 rounded-md animate-pulse" />
                </div>
              ))}
            </div>
            <div className="mt-6">
              <div className="h-10 bg-gray-200 rounded-md animate-pulse" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
